import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export type BillingTourId = 'dashboard' | 'reconcile' | 'onboarding' | 'mappings' | 'queries' | 'non-billable';

@Injectable({ providedIn: 'root' })
export class BillingTourCoordinatorService {
  private readonly request$ = new Subject<BillingTourId>();
  readonly tourRequest$ = this.request$.asObservable();

  requestTour(id: BillingTourId): void {
    this.request$.next(id);
  }
}
